import { DashboardService } from '../../../../../service/events/dashboard.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseForm } from '../../../../base-form';
import { PlanAbonadoFormDefinition } from './form-control/form-definition';
import { TareasApiService } from '../../../../../service/api/tareas-api.service';
import { FincasApiService } from '../../../../../service/api/fincas-api.service';
import { ProductosApiService } from '../../../../../service/api/productos-api';
import { TrabajadoresApiService } from '../../../../../service/api/trabajadores-api.service';
import { ClientesApiService } from '../../../../../service/api/clientes-api.service';
import { HttpClient } from '@angular/common/http';
import { SiexApiService } from '../../../../../service/api/siex-api.service';
import { PlanAbonadoModel } from 'src/app/models/tareas/plan-abonado.model';
import { build, pool } from 'src/app/common/classes/request-builder';
import { FormPhase } from 'src/app/common/components/reactive-form-builder/form-request';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { StorageManager } from 'src/app/common/storage-manager.class';
import { ComunidadesRegantesModel } from 'src/app/models/analisis/comunidadesRegantes.model';
import { AnalisisApiService } from 'src/app/service/api/analisis-api.service';
import { ReactiveFormRequestCoordinator } from 'src/app/common/components/reactive-form-builder/form-request-flow.coordinator';

@Component({
  selector: 'app-plan-abonado-form',
  standalone: false,
  templateUrl: './plan-abonado-form.component.html',
  styleUrls: ['./plan-abonado-form.component.scss'],
})
export class PlanAbonadoFormComponent extends BaseForm<PlanAbonadoModel> implements OnInit, OnDestroy {
  public loadingData = true;

  public form!: PlanAbonadoFormDefinition;

  public formRequest: ReactiveFormRequestCoordinator<PlanAbonadoModel>;

  public getRequest = this.tareasApi.planAbonado.GET;

  public comunidadForm: FormGroup;

  constructor(
    public fincasApi: FincasApiService,
    public siexApi: SiexApiService,
    public tareasApi: TareasApiService,
    public productosApi: ProductosApiService,
    public trabajadoresApi: TrabajadoresApiService,
    public override router: Router,
    public override route: ActivatedRoute,
    public dashboardEvents: DashboardService,
    public clientesApi: ClientesApiService,
    public analisisApi: AnalisisApiService,
    private readonly formBuilder: FormBuilder,
    private readonly http: HttpClient
  ) {
    super(
      route,
      router,
      dashboardEvents,
      tareasApi.planAbonado.PUT,
      tareasApi.planAbonado.POST,
      'plan-abonado',
      'Editar Plan de Abonado',
      'Realizar Plan de Abonado',
      'Duplicar Plan de Abonado'
    );
    this.formRequest = new ReactiveFormRequestCoordinator<PlanAbonadoModel>;
    this.comunidadForm = this.formBuilder.group({
      nombre: ['', [Validators.required, Validators.maxLength(100)]],
      id_usuario: [StorageManager.getUser().id],
      id_cliente: [StorageManager.getClient()?.id ?? ''],
    });
  }

  public ngOnInit(): void {
    this.dropdownsFinalized = false;
    this.form = new PlanAbonadoFormDefinition(this.getType(), this.getModel() as Record<string, string>, null);
    this.initFormData();
    this.softInit(this.getType());
    this.form.requestType = this.getType();
  }

  formChanges(formModel: [object, string], tag: string): void {
    this.form.model = formModel as unknown as PlanAbonadoModel;
    this.form.tag = tag;
  }

  private initFormData(): Promise<unknown> {
    const buildsRequest = [
      build(this.siexApi.cultivosGET, [this.form.lists.cultivos, this.form.lists.cultivos_precedentes], 'cultivo', true),
      build(this.analisisApi.comunidadesRegantes.GET, this.form.lists.comunidadesRegantes, 'nombre'),
    ];

    return pool(buildsRequest, () => {
      this.formRequest.executePhase(FormPhase.UPDATE);
    }).then(() => {
      this.dropdownsFinalized = true;
      this.dropdownLoadTrigger.next();
      this.loadingData = false;
      return;
    })
      .catch((e) => {
        this.dropdownsFinalized = true;
        console.log('catch en pool: ' + e);
      });
  }

  public saveNewOption(): void {
    if (this.comunidadForm.invalid) {
      this.comunidadForm.markAllAsTouched();
      return;
    }

    const endpoint: string = `${this.form.env.serverUrl}/ws/index.php?p1=generic&p2=comunidades_regantes`;
    const payload: ComunidadesRegantesModel = this.comunidadForm.getRawValue();

    this.http.post<ComunidadesRegantesModel>(endpoint, payload)
      .subscribe({
        next: () => {
          this.comunidadForm.reset({
            nombre: '',
            id_usuario: StorageManager.getUser().id,
            id_cliente: StorageManager.getClient()?.id ?? '',
          });

          this.form.openDialog = false;

          pool([
            build(this.analisisApi.comunidadesRegantes.GET, this.form.lists.comunidadesRegantes, 'nombre'),
          ], () => {}).then(() => {
            const newName = payload.nombre;
            const match = this.form.lists.comunidadesRegantes.filtered
              .find((item: any) => item.value && item.value.nombre === newName);

            if (match) {
              const controlName = this.form.formType < 3 ? 'id_comunidad_regantes' : 'comunidad_regantes';
              const control = this.formBuilderRef?.model?.get(controlName);

              if (control) {
                control.patchValue(match.value?.id, { emitEvent: false });
                control.markAsPristine();
              }
            }

            this.dropdownLoadTrigger.next();
          });
        },
        error: (error: unknown) => {
          console.error('Error creating comunidad_regantes:', error);
        },
      });
  }
}